import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import {
  MAX_LICENSE_COUNT,
  getMinLicenseCount,
} from "src/utils/pay/licenseCount";

interface ILicenseCountProps {
  isRenew: boolean;
}

// 사용자 수
const LicenseCount = ({ isRenew }: ILicenseCountProps) => {
  const { isOciProduct } = useProductFlags();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  return (
    <Form.Group className="mb-3">
      <Form.Label>{t("siteType.basic.detail.plan.userNum")}</Form.Label>
      <Form.Control
        type="number"
        {...register("licenseCount", { valueAsNumber: true })}
        className="form-control custom-form width max-w-120"
        min={getMinLicenseCount(isOciProduct)}
        max={MAX_LICENSE_COUNT}
        onKeyDown={(e) =>
          ["e", "E", "+", "-", ".", "Enter"].includes(e.key) &&
          e.preventDefault()
        }
        disabled={isRenew}
        isInvalid={!!errors.licenseCount}
      />
      <Form.Control.Feedback type="invalid">
        <>{errors?.licenseCount?.message}</>
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default LicenseCount;
